<template>
  <div>
    <div v-if="file.url" class="mb-4">
      <label for="file" class="block text-sm font-medium leading-5 text-gray-700">Current file:</label>
      <a :href="file.url" target="_blank" class="underline block truncate mb-2">{{file.url}}</a>
      <label :for="label + '_delete'" class="inline-flex items-center mt-2">
        <input
          type="checkbox"
          :id="label + '_' + id + '_delete'"
          v-model="file.delete"
          class="form-checkbox"
        />
        <span class="ml-2">Delete</span>
      </label>
    </div>
    <file-input :value="file.new_url" @input="upload($event)" :label="label" :id="id" />
  </div>
</template>

<script>
let axios = require('axios')

export default {
  props: {
    id: {},
    value: {},
    label: {}
  },
  data() {
    return {
      file: this.value
    }
  },
  methods: {
    upload($event) {
      let data = new FormData()
      let file = $event
      data.append('file', file)
      axios
        .post(route('files.store'), data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.file.new_url = response.data
          this.$emit('input', this.file)
        })
    }
  },
  watch: {
    value() {
      this.file = this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>
